var Model = require("../types/Model");

module.exports = Model({
	name: "groupsettings",
	init,
	uninit,
	listeners,

	refresh,
	trackChanges
});

function listeners(){
	return {
		"connectivity:online": refresh,
		"orggroup:updated": handle_orggroup_update
	};
}

function init(){
	this._tracker = this.dispatcher.createTracker();
	this._orgGroup = null;
	this.push({});
	this.refresh();
}

function uninit(){
	this._tracker.off();
	this._tracker = null;
}

function refresh(){
	return this.api.org.group.settings()
		.then(setSettings.bind(this));
}

function handle_orggroup_update(group){
	this._orgGroup = group;
	this.trackChanges();
}

function setSettings(data){
	this.push(data);
}

function trackChanges(){
	var orgGroup = this._orgGroup;
	var tracker = this._tracker;

	if(!orgGroup) return;
	tracker.off();
	tracker.on(`mqtt:orggroup/${orgGroup}/settings/updated`, setSettings.bind(this));
}
